import { SITE } from "@/lib/siteConfig";

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-navy-900 text-warm-neutral border-t border-warm-neutral/10"
    >
      <div className="container-page py-16 md:py-20">
        <p className="font-heading text-4xl sm:text-5xl md:text-6xl leading-none tracking-tight">
          {SITE.shortName}
          <span className="text-warm-accent">.</span>
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 mt-12 border-t border-warm-neutral/10 pt-12">
          <div>
            <p className="font-body text-xs uppercase tracking-[0.2em] text-warm-accent mb-3">
              Business
            </p>
            <p className="font-body text-warm-neutral/80">
              {SITE.businessName}
            </p>
          </div>

          <div>
            <p className="font-body text-xs uppercase tracking-[0.2em] text-warm-accent mb-3">
              Location
            </p>
            <p className="font-body text-warm-neutral/80">{SITE.location}</p>
            <p className="font-body text-warm-neutral/60 text-sm mt-1">
              Serving {SITE.serviceArea}
            </p>
          </div>

          {/* CONTACT — email intentionally omitted until the domain mailbox is set up */}
          <div>
            <p className="font-body text-xs uppercase tracking-[0.2em] text-warm-accent mb-3">
              Contact
            </p>
            <p
              data-testid="footer-phone-placeholder"
              className="font-body text-warm-neutral/60"
            >
              {SITE.contact.phonePlaceholder}
            </p>
          </div>

          <div>
            <p className="font-body text-xs uppercase tracking-[0.2em] text-warm-accent mb-3">
              Legal
            </p>
            <a
              href="#"
              data-testid="footer-privacy-link"
              className="block font-body text-warm-neutral/60 hover:text-warm-neutral transition-colors duration-200"
            >
              Privacy Policy (placeholder)
            </a>
            <a
              href="#"
              data-testid="footer-terms-link"
              className="block font-body text-warm-neutral/60 hover:text-warm-neutral transition-colors duration-200 mt-1"
            >
              Terms of Use (placeholder)
            </a>
          </div>
        </div>

        <div className="border-t border-warm-neutral/10 mt-12 pt-8">
          <p className="font-body text-sm text-warm-neutral/50">
            &copy; {year} {SITE.businessName}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
